module.exports = __webpack_public_path__ + "static/img/newsimg7.cdd0a73e.jpg";